import { useState } from 'react';
import ChartWidget from '../components/ChartWidget';
import CapSeriesChart from '../components/CapSeriesChart';
import ContractChartWidget from '../components/ContractChartWidget';
import GenericOptionsWidget from '../components/GenericOptionsWidget';

export default function Options() {
  // Shared timeframe for SPY + Cap Series charts
  const [tf, setTf] = useState('1m');

  // Selected contract for the contract chart (set by GenericOptionsWidget)
  const [selectedContract, setSelectedContract] = useState(null);

  return (
    <div>
      <ChartWidget tf={tf} setTf={setTf} />
      <CapSeriesChart tf={tf} setTf={setTf} />
      <ContractChartWidget contract={selectedContract} />
      <GenericOptionsWidget onContractSelect={setSelectedContract} />
    </div>
  );
}
